import { render, staticRenderFns } from "./SadasiForm.vue?vue&type=template&id=cc2201d8&"
import script from "./SadasiForm.vue?vue&type=script&lang=js&"
export * from "./SadasiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QSelect,QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QSelect,QList,QItem,QItemSection,QItemLabel})
